import { eventBus, INTERNAL_EVENTS } from '@cometchat/calls-sdk-core';

let screenLock: WakeLockSentinel | undefined;

async function handleVisibilityChange() {
  if (screenLock?.released && document.visibilityState === 'visible') {
    await releaseScreenLock();
    requestWakeLock();
  }
}

async function requestWakeLock() {
  if (navigator.wakeLock?.request) {
    navigator.wakeLock
      .request('screen')
      .then(lock => {
        screenLock = lock;
      })
      .catch(error => {
        console.error('Failed to acquire wake lock:', error);
      });
  }
}

async function releaseScreenLock() {
  if (screenLock) {
    await screenLock.release();
    screenLock = undefined;
    console.log('Wake lock released');
  }
}

eventBus.subscribe(INTERNAL_EVENTS.onConnectionEstablished, () => {
  requestWakeLock();
  document.addEventListener('visibilitychange', handleVisibilityChange);
});

eventBus.subscribe(INTERNAL_EVENTS.connectionWillClose, () => {
  document.removeEventListener('visibilitychange', handleVisibilityChange);
  releaseScreenLock();
});
